import type { HTMLAttributes } from 'react';

import { cn } from '@/lib/utils';

export interface MHDividerProps extends HTMLAttributes<HTMLDivElement> {
  label?: string;
  labelClassName?: string;
}

export function MHDivider({ label = 'OR', className, labelClassName, ...props }: MHDividerProps) {
  return (
    <div className={cn('flex items-center gap-3', className)} {...props}>
      <span className="h-px flex-1 bg-border-subtle" aria-hidden="true" />
      <span className={cn('text-caption font-medium text-text-tertiary', labelClassName)}>{label}</span>
      <span className="h-px flex-1 bg-border-subtle" aria-hidden="true" />
    </div>
  );
}
